/**
 * Email validation utilities
 */

export interface EmailValidationResult {
    isValid: boolean
    errorMessage?: string
}

/**
 * Validates email format using a comprehensive regex pattern
 * @param email - The email address to validate
 * @returns EmailValidationResult with validation status and error message
 */
export const validateEmail = (email: string): EmailValidationResult => {
    // Comprehensive email regex that follows RFC 5322 standards
    const emailRegex =
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

    if (!email || email.trim() === '') {
        return {
            isValid: false,
            errorMessage: 'emailRequired',
        }
    }

    if (!emailRegex.test(email.trim())) {
        return {
            isValid: false,
            errorMessage: 'emailInvalid',
        }
    }

    return {
        isValid: true,
    }
}

/**
 * Validates email format for real-time validation (less strict)
 * @param email - The email address to validate
 * @returns boolean indicating if email format is valid
 */
export const isValidEmailFormat = (email: string): boolean => {
    if (!email || email.trim() === '') {
        return false
    }

    // Basic email format check for real-time validation
    const basicEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return basicEmailRegex.test(email.trim())
}

/**
 * Checks if email is empty or whitespace only
 * @param email - The email address to check
 * @returns boolean indicating if email is empty
 */
export const isEmailEmpty = (email: string): boolean => {
    return !email || email.trim() === ''
}
